/* eslint-disable max-len */
import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationPreferenceUpdate } from '@acp/shared';
import { updatePropertyManagerNotificationPreferences } from '../../agency/service';

export function useNotificationPreferencesUpdate() {
    const toast = useToast();
    const queryClient = useQueryClient();

    const updateMutation = useMutation({
        mutationFn: async (settings: NotificationPreferenceUpdate) => updatePropertyManagerNotificationPreferences(settings),
        onSuccess: () => {
            toast({
                title: 'Notification preference updated',
                description: 'Notification preference has been successfully updated.',
                status: 'success',
                isClosable: true,
            });

            void queryClient.invalidateQueries({
                queryKey: ['property-manager', 'notification-preferences'],
            });
        },
        onError: (error) => {
            toast({
                title: 'Error updating notification preference',
                description: error.message,
                status: 'error',
                isClosable: true,
            });
        },
    });

    return {
        update: updateMutation.mutateAsync,
        isPending: updateMutation.isPending,
        reset: updateMutation.reset,
    };
}
